<template>
  <section class="news-box">
    <Title :title="'资讯列表'" />
    <List :list="newsData" :source="'MOTEDETAIL'"  />
  </section>
</template>
<script>
  import { mapGetters } from 'vuex'
  import List from '@/components/List'
  import Title from '@/components/TitleM'

  export default {
    // 服务器端渲染，预加载模特资讯页面数据
    asyncData ({ store, route }) {
      return store.dispatch('getNewsData', route.params.name)
    },
    components: { List, Title },
    computed: {
      ...mapGetters({
        newsData: 'newsData'
      }),
    }
  }
</script>
<style lang="scss" scoped>
  .list-ul {
    margin-top: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/News.vue